// "Desktop view": an override of the automatic layout, for showing the wide
// screen on a phone (a demo). It is NOT a mode. Width still picks the layout by
// default, and nothing is reachable only through this switch.
//
// It works by widening the layout viewport, the same trick as a mobile browser's
// "Request desktop site": the page lays out at 1280px and the phone scales it
// down, so the existing wide-screen CSS applies with no second layout.
//
// The choice is a per-device convenience kept in localStorage. Storage can throw
// (private window, blocked site data), so every access is guarded and the page
// is correct without it.

const KEY = 'msc.desktopView';
const DESKTOP_WIDTH = 1280;
const AUTO = 'width=device-width, initial-scale=1, viewport-fit=cover';
const FORCED = `width=${DESKTOP_WIDTH}, viewport-fit=cover`;

export function isDesktopView(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/** Write the viewport meta for the current choice. Idempotent. */
export function applyViewMode(): void {
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  meta.setAttribute('content', isDesktopView() ? FORCED : AUTO);
}

export function setDesktopView(on: boolean): void {
  try {
    if (on) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    // Nothing to persist to; the change below still applies for this page.
  }
  applyViewMode();
}
